<template>
  <div class="">
    <div class="x-banner">
      <BANNER></BANNER>
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jxky/home">教学科研</router-link> >
      <router-link to="/jxky/byhyxjy">毕业后医学教育</router-link>
    </div>

    <!-- <div class="container-width x-article">
      <div class="pt50"></div>
      <div class="l-content">
        <div class="list" @click="goTraining">
          <div>培训基地</div>
          <a class="more">查看更多>></a>
        </div>
        <div class="train-description" v-html="trainingData.description"></div>
      </div>
      <div class="l-content">
        <div class="list" @click="goProfessional">
          <div>专业基地</div>
          <a class="more">查看更多>></a>
        </div>
        <div class="">
          <ul class="ulPartList">
            <li
              class="li"
              v-for="(item, index) in professionalData"
              :key="index"
            >
              <a @click="goProfessionalArticle(item.id)" class="wh_dot">
                {{ item.keyword }}</a
              >
            </li>
          </ul>
          <div class="clear"></div>
        </div>
      </div>
      <div class="l-content">
        <div class="list" @click="goDynamic">
          <div>培训动态</div>
          <a class="more">查看更多>></a>
        </div>
        <div class="">
          <ul class="xx1_lb huli">
            <li v-for="(item, index) in dynamicData" :key="index">
              <a @click="godynamicArticle(item.id)" :title="item.title">{{
                item.title
              }}</a>
              <span class="zt_9d">{{ item.releaseDate }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div> -->

    <div class="container-width x-article">
      <div class="byhyxjy">
        <div class="item" @click="goTraining">
          <i class="iconfont icon-jidi"></i>
          <div class="txt">培训基地</div>
          <a class="more">查看更多>></a>
        </div>
        <div class="item" @click="goProfessional">
          <i class="iconfont icon-renshizhuanye"></i>
          <div class="txt">专业基地</div>
          <a class="more">查看更多>></a>
        </div>
        <div class="item" @click="goDynamic">
          <i class="iconfont icon-shuyi_shangke-peixun"></i>
          <div class="txt">培训动态</div>
          <a class="more">查看更多>></a>
        </div>
      </div>
    </div>
    <div class="mt50"></div>
  </div>
</template>
<script>
import service from "../../service/jxky";
import BANNER from "../../components/banner/jxky";
import { jxkyNavDic } from "../../const/navigationData";
export default {
  name: "JXKY",
  data() {
    return {
      navigationData: jxkyNavDic,
      currentPath: "/jxky/byhyxjy",
      trainingData: {},
      professionalData: [],
      dynamicData: [],
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      service.getTraining({}, (res) => {
        this.trainingData = res.object || {};
      });
      let data = {
        types: "",
      };
      service.getAllProfessionalBase(data, (res) => {
        this.professionalData = res.object || [];
      });
      let parmes = {
        pageIndex: 1,
        pageSize: 6,
        // isshow: 1,
      };
      service.getAllTrainingDynamic(parmes, (res) => {
        this.dynamicData = res.content || [];
      });
    },

    goTraining() {
      const { href } = this.$router.resolve({
        path: `/jxky/training`,
      });
      window.open(href, "_self");
    },
    goProfessional() {
      const { href } = this.$router.resolve({
        path: `/jxky/professional`,
      });
      window.open(href, "_self");
    },
    goProfessionalArticle(id) {
      let articleId = id || 0;
      const { href } = this.$router.resolve({
        path: `/jxky/professional/article/${articleId}`,
      });
      window.open(href, "_blank");
    },
    goDynamic() {
      const { href } = this.$router.resolve({
        path: `/jxky/dynamic`,
      });
      window.open(href, "_self");
    },
    godynamicArticle(id) {
      let parmes = {
        id: id,
      };
      this.$router.push({
        path: "/jxky/dynamic/article",
        query: parmes,
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.pt50 {
  padding-top: 50px;
}
.w-more {
  margin-top: 30px;
  margin-bottom: 30px;
}
.byhyxjy {
  display: flex;
  justify-content: space-between;
  padding: 50px;
  .item {
    flex: 1;
    border-top: 4px solid #00479d;
    padding: 55px 35px 55px;
    border-radius: 8px;
    transition: transform 0.5s ease-in-out;
    margin-right: 30px;
    box-shadow: 0 0 30px 0 rgba(6, 30, 98, 0.08);
    transition: transform 0.5s ease-in-out;
    transition: all 0.4s ease 0s;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    cursor: pointer;
    i {
      font-size: 2.4rem;
      font-weight: 500;
    }
    .txt {
      font-size: 1.2rem;
    }
    .more {
      color: #999999;
      font-size: 0.8rem;
      margin-top: 10px;
    }
  }
  .item:hover {
    background: #00479d;
    color: #ffffff;

    .more {
      color: #ffffff;
    }
  }
  .item::before {
    content: "";
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #00479d;
    color: #ffffff;
    border-radius: 5px 5px 8px 8px;
    position: absolute;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.5s ease-in-out;
    z-index: -1;
  }
  .item:hover:before {
    transform: scaleX(1);
    transform-origin: left;
  }
}
// .x-article {
//   -webkit-transition: all 0.5s ease 0s;
//   -moz-transition: all 0.5s ease 0s;
//   transition: all 0.5s ease 0s;
//   box-shadow: 4px 4px #ececec;
//   margin-bottom: 50px;
//   border: 1px solid #ebebeb;
//   border-top: none;
//   box-sizing: border-box;

//   .title {
//     padding-top: 30px;
//     padding-bottom: 30px;
//     font-weight: bold;
//     text-align: center;
//     border-bottom: 1px solid #ebebeb;
//     font-size: 1.4rem;
//   }
//   .l-content {
//     // padding: 50px 50px 50px 50px;
//     margin: 0 50px 0 50px;
//     .list {
//       font-size: 1.2rem;
//       background: #00479d;
//       color: #fff;
//       cursor: pointer;
//       height: 60px;
//       line-height: 60px;
//       padding-left: 10px;
//       padding-right: 10px;
//       display: flex;
//       justify-content: space-between;
//       .more {
//         font-size: 0.875rem;
//       }
//     }
//     .train-description {
//       font-size: 1.2rem;
//       line-height: 40px;
//       overflow: hidden;
//       text-overflow: ellipsis;
//       -webkit-line-clamp: 6;
//       display: -webkit-box;
//       -webkit-box-orient: vertical;
//       margin-top: 30px;
//       margin-bottom: 30px;
//     }
//     .ulPartList {
//       margin-top: 30px;
//       margin-bottom: 30px;
//     }
//     .xx1_lb {
//       margin-top: 30px;
//       margin-bottom: 30px;
//     }
//   }
// }
@media only screen and (max-width: 720px) {
  .byhyxjy {
    // flex-direction: column;
    padding: 30px;
    .item {
      padding: 35px 5px 35px;
      margin-top: 20px;
      i {
        font-size: 2rem;
        font-weight: 500;
      }
      .txt {
        font-size: 1rem;
      }
    }
  }
}
@media only screen and (max-width: 421px) {
  .pt50 {
    padding-top: 30px;
  }

  .byhyxjy {
    flex-direction: column;
    padding: 30px;
    align-items: center;
    .item {
      padding: 25px 0px 25px;
      margin-top: 20px;
      margin-right: 0;
      flex: 1;
      width: 100%;
      i {
        font-size: 2rem;
        font-weight: 500;
      }
      .txt {
        font-size: 1rem;
      }
    }
  }
}
</style>
